import { render, staticRenderFns } from "./FacturasGlobales.vue?vue&type=template&id=232c2ca5&scoped=true"
import script from "./FacturasGlobales.vue?vue&type=script&lang=js"
export * from "./FacturasGlobales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232c2ca5",
  null
  
)

export default component.exports